/* vito-size-advisor.js
   Zweck:  Groessenberatung — aus Gewicht und Schulterhoehe oder aus der Rasse
           wird die passende Groesse berechnet, angezeigt und auf Klick im
           Varianten-Waehler des Themes gesetzt.
   Basis:  Concept 6.0.0 — Event "variant:change" auf dem Produktformular,
           Varianten-Waehler <variant-picker> mit fieldset[data-option-index]
           und input[data-option-value].
   Regel:  Keine Zahl, kein Text und keine Rasse steht in diesem Skript.
           Alles kommt aus den Block-Einstellungen bzw. den Sprachdateien.
*/

(function () {
  /* Kanonische Groessenleiter. Nur zum Vergleichen, nicht zum Anzeigen —
     angezeigt wird immer die echte Variantenbezeichnung des Produkts. */
  var LADDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];

  function num(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  class VitoSizeAdvisor extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.i18n = this.json('data-i18n', {});
      this.sizes = this.json('data-sizes', []);
      this.scale = this.csv('data-scale');
      this.wSteps = this.csv('data-weight-steps').map(num).filter(function (n) { return n !== null; });
      this.hSteps = this.csv('data-height-steps').map(num).filter(function (n) { return n !== null; });
      this.breeds = this.parseBreeds(this.json('data-breeds', '') || '');
      this.remember = this.getAttribute('data-remember') === '1';
      this.formId = this.getAttribute('form') || '';
      this.pickerId = this.getAttribute('data-picker') || '';
      this.optionIndex = this.getAttribute('data-option-index') || 'option1';

      this.root = this.querySelector('[data-vito-adv-root]');
      this.head = this.querySelector('[data-vito-adv-head]');
      this.body = this.querySelector('[data-vito-adv-body]');
      this.resultEl = this.querySelector('[data-vito-adv-result]');
      this.wEl = this.querySelector('[data-vito-adv="weight"]');
      this.hEl = this.querySelector('[data-vito-adv="height"]');
      this.bEl = this.querySelector('[data-vito-adv="breed"]');

      this.state = { w: '', h: '', breed: '' };

      this.fillBreeds();
      this.restore();
      this.bind();
      this.render();

      if (this.getAttribute('data-open') === '1' || this.hasInput()) this.open(true);
    }

    disconnectedCallback() {
      if (this.formTarget && this.onVariant) {
        this.formTarget.removeEventListener('variant:change', this.onVariant);
      }
    }

    /* ---------- Daten ---------- */

    json(attr, fallback) {
      try {
        var v = JSON.parse(this.getAttribute(attr) || '');
        return v == null ? fallback : v;
      } catch (e) { return fallback; }
    }

    csv(attr) {
      return (this.getAttribute(attr) || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
    }

    /* Tolerant: Trennzeichen egal. Name ist alles vor der ersten Zahl,
       danach gelten die ersten zwei Zahlen als Gewicht und Schulterhoehe.
       So haelt die Liste auch eine maschinelle Uebersetzung aus. */
    parseBreeds(raw) {
      var out = [];
      raw.split(/\r?\n/).forEach(function (line, i) {
        var s = line.trim();
        if (!s) return;
        var nums = s.match(/\d+(?:[.,]\d+)?/g);
        if (!nums || nums.length < 2) return;
        var cut = s.indexOf(nums[0]);
        var name = s.slice(0, cut).replace(/[\s|;,:\-–—]+$/, '').trim();
        if (!name) return;
        out.push({ key: String(i), name: name, kg: num(nums[0]), cm: num(nums[1]) });
      });
      return out;
    }

    fillBreeds() {
      if (!this.bEl) return;
      if (!this.breeds.length) {
        var field = this.bEl.closest('[data-vito-adv-breed-field]');
        if (field) field.hidden = true;
        var or = this.querySelector('[data-vito-adv-or]');
        if (or) or.hidden = true;
        return;
      }
      var frag = document.createDocumentFragment();
      this.breeds.forEach(function (b) {
        var o = document.createElement('option');
        o.value = b.key;
        o.textContent = b.name;
        frag.appendChild(o);
      });
      this.bEl.appendChild(frag);
    }

    /* ---------- Gedaechtnis ---------- */

    get storeKey() { return 'vito:dog'; }

    restore() {
      if (!this.remember) return;
      var saved = null;
      try { saved = JSON.parse(window.localStorage.getItem(this.storeKey) || 'null'); } catch (e) { saved = null; }
      if (!saved) return;

      if (saved.w != null && this.wEl) { this.state.w = String(saved.w); this.wEl.value = this.state.w; }
      if (saved.h != null && this.hEl) { this.state.h = String(saved.h); this.hEl.value = this.state.h; }
      /* Rassen werden ueber den Namen wiedererkannt, nicht ueber den Index —
         die Liste kann sich aendern. */
      if (saved.breedName && this.bEl) {
        var hit = this.breeds.filter(function (b) { return b.name === saved.breedName; })[0];
        if (hit) { this.state.breed = hit.key; this.bEl.value = hit.key; }
      }
    }

    save() {
      if (!this.remember) return;
      var b = this.breed();
      try {
        window.localStorage.setItem(this.storeKey, JSON.stringify({
          w: this.state.w, h: this.state.h, breedName: b ? b.name : ''
        }));
      } catch (e) { /* privater Modus oder voller Speicher — kein Grund abzubrechen */ }
    }

    /* ---------- Aufklappen ---------- */

    hasInput() {
      return !!(this.state.w || this.state.h || this.state.breed);
    }

    open(state) {
      this.isOpen = !!state;
      if (this.root) this.root.classList.toggle('is-open', this.isOpen);
      if (this.body) this.body.hidden = !this.isOpen;
      if (this.head) this.head.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
    }

    /* ---------- Ereignisse ---------- */

    bind() {
      var self = this;

      if (this.head) {
        this.head.addEventListener('click', function () { self.open(!self.isOpen); });
      }

      ['input', 'change'].forEach(function (ev) {
        self.addEventListener(ev, function (e) {
          var t = e.target;
          if (!t || !t.dataset) return;
          var role = t.dataset.vitoAdv;

          if (role === 'weight') { self.state.w = t.value; self.save(); self.render(); }
          else if (role === 'height') { self.state.h = t.value; self.save(); self.render(); }
          else if (role === 'breed') {
            self.state.breed = t.value;
            var b = self.breed();
            /* Leere Felder werden aus der Rasse vorbelegt, eingetragene bleiben stehen. */
            if (b) {
              if (!self.state.w && self.wEl) { self.state.w = String(b.kg); self.wEl.value = self.state.w; }
              if (!self.state.h && self.hEl) { self.state.h = String(b.cm); self.hEl.value = self.state.h; }
            }
            self.save();
            self.render();
          }
        });
      });

      this.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-vito-adv-apply]');
        if (!btn) return;
        self.applySize(btn.getAttribute('data-vito-adv-apply'));
      });

      this.onVariant = function () { self.render(); };
      this.formTarget = this.form || document;
      this.formTarget.addEventListener('variant:change', this.onVariant);
    }

    get form() {
      return this.formId && document.forms[this.formId] ? document.forms[this.formId] : null;
    }

    /* ---------- Varianten-Waehler des Themes ---------- */

    get picker() {
      return this.pickerId ? document.getElementById(this.pickerId) : null;
    }

    get fieldset() {
      var p = this.picker;
      return p ? p.querySelector('fieldset[data-option-index="' + this.optionIndex + '"]') : null;
    }

    radios() {
      var fs = this.fieldset;
      return fs ? Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')) : [];
    }

    currentLabel() {
      var hit = this.radios().filter(function (r) { return r.checked; })[0];
      return hit ? (hit.getAttribute('data-option-value') || hit.value || '') : '';
    }

    applySize(label) {
      var hit = this.radios().filter(function (r) {
        return (r.getAttribute('data-option-value') || r.value) === label;
      })[0];
      if (hit && !hit.checked) hit.click();
    }

    highlight(entry) {
      var p = this.picker;
      if (!p) return;
      p.querySelectorAll('.label-swatch.vito-recommended').forEach(function (el) {
        el.classList.remove('vito-recommended');
      });
      if (!entry || entry.label === this.currentLabel()) return;
      this.radios().forEach(function (r) {
        if ((r.getAttribute('data-option-value') || r.value) !== entry.label) return;
        var lab = r.parentElement && r.parentElement.querySelector('.label-swatch');
        if (lab) lab.classList.add('vito-recommended');
      });
    }

    /* ---------- Rechnen ---------- */

    breed() {
      var key = this.state.breed;
      if (!key) return null;
      return this.breeds.filter(function (b) { return b.key === key; })[0] || null;
    }

    bucket(value, steps) {
      var i = 0;
      for (var k = 0; k < steps.length; k++) { if (value >= steps[k]) i = k + 1; }
      return i;
    }

    compute() {
      var w = num(this.state.w);
      var h = num(this.state.h);
      var b = this.breed();

      if (b) {
        if (w === null) w = b.kg;
        if (h === null) h = b.cm;
      }
      /* Vorgabe: Empfehlung erst bei (Gewicht UND Schulterhoehe) ODER gewaehlter Rasse. */
      if (!b && (w === null || h === null)) return null;

      var idx = -1;
      if (w !== null && this.wSteps.length) idx = Math.max(idx, this.bucket(w, this.wSteps));
      if (h !== null && this.hSteps.length) idx = Math.max(idx, this.bucket(h, this.hSteps));
      if (idx < 0 || !this.scale.length) return null;

      var token = this.scale[Math.min(idx, this.scale.length - 1)].toUpperCase();
      var entry = this.resolve(token);
      return entry ? { token: token, entry: entry } : null;
    }

    /* Der berechnete Token wird auf eine Groesse gebracht, die das Produkt
       wirklich hat: die kleinste, die mindestens so gross ist. */
    resolve(token) {
      var rank = LADDER.indexOf(token);
      var known = this.sizes.filter(function (s) { return LADDER.indexOf(String(s.token).toUpperCase()) >= 0; });
      if (!known.length) return null;

      var withRank = known.map(function (s) {
        return { token: String(s.token).toUpperCase(), label: s.label, available: s.available !== false, rank: LADDER.indexOf(String(s.token).toUpperCase()) };
      }).sort(function (a, b) { return a.rank - b.rank; });

      if (rank < 0) return null;

      var exact = withRank.filter(function (s) { return s.rank === rank; })[0];
      if (exact) return exact;

      var bigger = withRank.filter(function (s) { return s.rank > rank; })[0];
      if (bigger) return bigger;

      return withRank[withRank.length - 1];
    }

    /* ---------- Anzeige ---------- */

    t(key, rep) {
      var raw = this.i18n[key];
      if (raw == null) return '';
      if (rep) {
        Object.keys(rep).forEach(function (k) {
          raw = raw.split('{{ ' + k + ' }}').join(rep[k]).split('{{' + k + '}}').join(rep[k]);
        });
      }
      return raw;
    }

    reason(token) {
      return this.t('reason_' + token.toLowerCase()) || this.t('reason_default');
    }

    render() {
      if (!this.resultEl) return;
      var rec = this.compute();

      /* Aufbau ueber DOM-Knoten, nicht ueber innerHTML — Merchant-Texte
         landen so nie als Markup auf der Seite. */
      this.resultEl.textContent = '';
      this.resultEl.classList.toggle('is-empty', !rec);

      var badge = document.createElement('span');
      badge.className = 'vito-adv__badge';
      badge.setAttribute('aria-hidden', 'true');

      var body = document.createElement('span');
      body.className = 'vito-adv__result-body';

      var title = document.createElement('span');
      title.className = 'vito-adv__result-title';

      var text = document.createElement('span');
      text.className = 'vito-adv__result-text';

      if (!rec) {
        badge.textContent = '?';
        title.textContent = this.t('empty_title');
        text.textContent = this.t('empty_text');
        body.appendChild(title);
        body.appendChild(text);
      } else {
        badge.textContent = rec.entry.token;
        title.textContent = this.t('rec_title', { size: rec.entry.label });
        text.textContent = this.reason(rec.entry.token);
        body.appendChild(title);
        body.appendChild(text);

        if (!rec.entry.available) {
          var so = document.createElement('span');
          so.className = 'vito-adv__state';
          so.textContent = this.t('soldout');
          body.appendChild(so);
        } else if (rec.entry.label === this.currentLabel()) {
          var done = document.createElement('span');
          done.className = 'vito-adv__state';
          done.textContent = this.t('applied');
          body.appendChild(done);
        } else {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vito-adv__apply';
          btn.setAttribute('data-vito-adv-apply', rec.entry.label);
          btn.textContent = this.t('apply', { size: rec.entry.label });
          body.appendChild(btn);
        }
      }

      this.resultEl.appendChild(badge);
      this.resultEl.appendChild(body);

      this.highlight(rec ? rec.entry : null);
    }
  }

  if (!customElements.get('vito-size-advisor')) {
    customElements.define('vito-size-advisor', VitoSizeAdvisor);
  }
})();
